import { useEffect, useRef, useState } from 'react'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'

import { fetchMe } from '../../../main/usecases'

import { useModalBox } from '../../contexts'
import { Banner } from '../../components'

import * as S from './styles'
import { FirstStepsModalFactory } from '../../../main/factories'
import MyClients from '../my-clients'
import ReactJoyride from 'react-joyride'
import theme from '../../styles/theme'

const Home = () => {
  const [runTuto, setRunTuto] = useState<boolean>(false)
  // const [homeData, setHomeData] = useState<HomeModel>()
  const { modalBox } = useModalBox()

  const userData = JSON.parse(localStorage.getItem('user') || '')
  const tawkMessengerRef: any = useRef()
  const customStyle = {
    visibility: {
      desktop: {
        position: 'br'
      },
      mobile: {
        position: ' br'
      }
    }
  }

  const tawkToDataLoad = () => {
    tawkMessengerRef.current.setAttributes({
      name: userData.usuario.nome,
      email: userData.usuario.email
    })
  }

  useEffect(() => {
    // ;(async () => {
    //   try {
    //     const responseHome = await fetchHome().load()
    //     setHomeData(responseHome)
    //   } catch (error) {
    //     console.error(error)
    //   }
    // })()
    ;(async () => {
      const me = await fetchMe().load()
      if (
        !me.cpf ||
        !me.usuario.email ||
        !me.usuario.nome ||
        !me.contato.contato
      ) {
        modalBox(<FirstStepsModalFactory />, null, '40%', 'auto', true)
      }
    })()
    const serviceIdQuery = new URLSearchParams(location.search).get('tutorial')
    if (serviceIdQuery === 'add-customer') {
      setRunTuto(true)
    }
  }, [modalBox])

  return (
    <S.Wrapper>
      <Banner />
      <ReactJoyride
        run={runTuto}
        steps={[
          {
            content: (
              <h2>Clique aqui para adicionar o seu Primeiro Paciente</h2>
            ),
            locale: {
              last: 'Ok',
              close: 'Ok'
            },
            styles: {
              buttonClose: {
                backgroundColor: theme.colors.primary
              }
            },
            showSkipButton: false,
            hideCloseButton: true,
            hideBackButton: true,
            spotlightPadding: 20,
            disableBeacon: true,
            target: '.create-customer'
          }
        ]}
        styles={{
          options: {
            zIndex: 10000
          }
        }}
        hideCloseButton
        continuous={false}
      />
      <S.MainContent>
        <TawkMessengerReact
          customStyle={customStyle}
          propertyId="62a247fb7b967b117993be13"
          widgetId="1g54uicbc"
          onLoad={tawkToDataLoad}
          ref={tawkMessengerRef}
        />
        <MyClients setRunTuto={setRunTuto} />
        {/* <S.ShotcutContent>
          <h2>Meus atalhos</h2>
          <S.CardsContainer>
            <SmallHomeCard
              onClick={handleClickNewService}
              title="Novo laudo"
              icon="new-service"
            />
            <SmallHomeCard
              onClick={handleClickNewClientRegister}
              title="Novo cadastro"
              icon="new-register"
            />
            <SmallHomeCard
              link="/meus-pacientes"
              title="Meus pacientes"
              icon="my-customers"
            />
            <SmallHomeCard
              className="disabled"
              title="Comprar crédito"
              icon="buy-credit"
            />
            {homeData && (
              <>
                <BigHomeCard
                  title="Documentos psicológicos gerados"
                  newData={`${
                    homeData?.qntDocumentos
                  } documentos em ${currentMonth()}`}
                  percentage={homeData?.percentQntdDocumentos}
                />
                <BigHomeCard
                  title="Pacientes cadastrados"
                  newData={`${
                    homeData?.qntCadastros
                  } pacientes em ${currentMonth()}`}
                  percentage={homeData?.percentQntdCadastros}
                />
              </>
            )}
          </S.CardsContainer>
        </S.ShotcutContent> */}
        <S.MyConsumptionContent>
          {/* <h2>Meu Consumo</h2> */}
        </S.MyConsumptionContent>
      </S.MainContent>
    </S.Wrapper>
  )
}
export default Home
